import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import {
  IntervenientsSignatureDTO,
  IntervenersDigitalSignatureDTO,
  SessionDataLogalty,
  ConsentExpressDTOReturn,
  ConsentExpressRequestDTO,
  ConsentRequestDTO,
  SignatureSamlDTO,
  SignatureSAMLResponseDTO,
  startAsyncSignatureDTO,
  SignatureSamlMerchantDTO,
  ThirdPartySignatureResponseDTO,
} from '@app/requests/model/logalty-signature-model';

@Injectable({
  providedIn: 'root',
})
export class DigitalSignatureServiceApi {
  constructor(private _http: HttpClient) {}

  public postResultConsent(consentRequest: ConsentRequestDTO): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_SIGNATURE + environment.subUrlSendConsent, consentRequest);
  }

  public getParticipantsSignature(signatureDTO: IntervenientsSignatureDTO): Observable<IntervenersDigitalSignatureDTO> {
    return this._http.post<IntervenersDigitalSignatureDTO>(
      environment.URL_BASE_SIGNATURE + environment.subUrlParticipantsSignature,
      signatureDTO
    );
  }

  public getSessionDataLogalty(consentExpress: ConsentExpressRequestDTO): Observable<ConsentExpressDTOReturn> {
    return this._http.post<ConsentExpressDTOReturn>(
      environment.URL_BASE_SIGNATURE + environment.subUrlGetConsent,
      consentExpress
    );
  }

  public getSAMLLogalty(saml: SignatureSamlDTO): Observable<SignatureSAMLResponseDTO> {
    return this._http.post<SignatureSAMLResponseDTO>(environment.URL_BASE_SIGNATURE + environment.subUrlGetSaml, saml);
  }

  public getSAMLMerchantLogalty(saml: SignatureSamlMerchantDTO): Observable<SignatureSAMLResponseDTO> {
    return this._http.post<SignatureSAMLResponseDTO>(
      environment.URL_BASE_SIGNATURE + environment.subUrlGetMerchantSaml,
      saml
    );
  }

  public getStartAsyncSignature(encryptCode: string): Observable<startAsyncSignatureDTO> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this._http.post<startAsyncSignatureDTO>(
      environment.URL_BASE_SIGNATURE + environment.subUrlStartAsyncSignature,
      encryptCode,
      { headers: headers }
    );
  }

  public getStartAsyncSignatureMerchant(encryptCode: string): Observable<any> {
    // TODO cambiar any
    let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this._http.post<any>( // TODO cambiar any
      environment.URL_BASE_SIGNATURE + environment.subUrlStartAsyncMerchantSignature,
      encryptCode,
      { headers: headers }
    );
  }

  public postSendEmailAsyncSignature(numOperation: string): Observable<boolean> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
    return this._http.post<boolean>(
      environment.URL_BASE_SIGNATURE + environment.subUrlSendEmailsignatureAsync,
      numOperation,
      { headers: headers }
    );
  }

  // thrird party end point
  public getSAMLThirdPartyFromExternalId(encryptCode: string): Observable<ThirdPartySignatureResponseDTO> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Signature', 'token');
    return this._http.post<ThirdPartySignatureResponseDTO>(
      environment.URL_BASE_THIRDPARTY + environment.subUrlSAMLThirdPartyFromExternalId,
      encryptCode,
      { headers }
    );
  }

  public postSetSignFinish(encryptCode: string): Observable<boolean> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8').set('Signature', 'token');
    return this._http.post<boolean>(environment.URL_BASE_THIRDPARTY + environment.subUrlSetSignFinish, encryptCode, {
      headers,
    });
  }

  /*
   ** [ESPSCFWMTS-4641] Due to a change of requirements this code is considered dead but it won't
   ** be removed until the EVO is confirmed to be valid.
   */
  // postRejectSignature = (rejectSignatureRequest: RejectSignatureRequest): Observable<any> => {
  //   return this._http.post<any>(
  //     environment.URL_BASE_SIGNATURE + environment.subUrlRejectSignature,
  //     rejectSignatureRequest
  //   );
  // };
}
